<dsr-card-base *ngIf="isDataLoaded">
  <div class="card card-container" [hidden]="!showForm">
    <dsr-header ghost></dsr-header>
    <div style="margin-bottom: 15px; display: flex; justify-content: right">
      <dsr-brand brand="{{ redeOrange }}" style="width: 100px"></dsr-brand>
    </div>

    <dsr-typography type="heading" size="small">
      Consentimento requerido
    </dsr-typography>

    <div class="row" style="margin-top: 5%; margin-bottom: 5%">
      <div class="col text-left img-text">
        <dsr-typography type="paragraph">
          As seguintes permissões são requisitadas para o acesso na plataforma
          de soluções do parceiro.<br />
          Por favor avalie as possíveis permissões e dê o consentimento para
          avançar.
        </dsr-typography>
      </div>
    </div>

    <div class="row">
      <div class="col text-left">
        <form
          #formConsent
          id="form-consent"
          name="consent_form"
          (submit)="onSubmit($event)"
        >
          <input type="hidden" name="client_id" value="{{ clientId }}" />
          <input type="hidden" name="state" value="{{ state }}" />
          <div *ngFor="let scope of requestedScopes" style="display: none">
            <input
              class="form-check-input"
              type="checkbox"
              style="margin-top: 0.7rem"
              name="scope"
              id="{{ scope }}"
              value="{{ scope }}"
              checked
              readonly="readonly"
            />
            <label
              class="form-check-label"
              for="{{ scope }}"
              style="margin-top: 0.3rem; margin-left: 0.3rem"
              >{{ scope }}</label
            >
          </div>

          <div
            *ngFor="let scope of newScopes"
            class="form-group py-1 consentimentos consent-checkbox-div"
          >
            <dsr-checkbox
              label="{{ recuperarAlias(scope.code) }}"
              checked="true"
              disabled="true"
            ></dsr-checkbox>
          </div>

          <div
            style="margin-top: 10px; text-align: center; margin-bottom: 5px"
            *ngIf="authorizedScopes && authorizedScopes.length > 0"
          >
            <dsr-typography type="caption">
              Você já concedeu as seguintes permissões
            </dsr-typography>
          </div>
          <div
            *ngFor="let scope of authorizedScopes"
            class="form-group py-1 consentimentos consent-checkbox-div"
          >
            <dsr-checkbox
              label="{{ recuperarAlias(scope.code) }}"
              checked="true"
              disabled="true"
            ></dsr-checkbox>
          </div>

          <div class="form-group pt-3">
            <dsr-button submit style="display: flex; justify-content: center"
              >Conceder consentimento</dsr-button
            >
          </div>
          <div class="form-group" style="text-align: center">
            <dsr-link href="https://www.userede.com.br/n/termos-de-uso"
              >Termos de uso e política de privacidade</dsr-link
            >
          </div>
          <div class="form-group" style="text-align: center">
            <dsr-link (click)="cancelConsent()">voltar para parceiro</dsr-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</dsr-card-base>
